(() => {
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  const minimumFontSize = 14;
  let animationFrame;

  function fitProductTitles() {
    const titles = document.querySelectorAll('.product__title > h1');

    titles.forEach((title) => {
      // Clear previous calculations.
      title.style.removeProperty('font-size');
      title.style.removeProperty('white-space');
      title.style.removeProperty('line-height');

      // Leave desktop styling unchanged.
      if (!mobileBreakpoint.matches) return;

      const naturalFontSize = parseFloat(
        window.getComputedStyle(title).fontSize
      );

      title.style.whiteSpace = 'nowrap';
      title.style.lineHeight = '1.15';

      // The normal title size already fits.
      if (title.scrollWidth <= title.clientWidth) return;

      // Check whether it fits at the minimum readable size.
      title.style.fontSize = `${minimumFontSize}px`;

      if (title.scrollWidth > title.clientWidth) {
        // This title is too long even at the minimum size.
        // Allow two lines instead of making it unreadably small.
        title.style.removeProperty('font-size');
        title.style.whiteSpace = 'normal';
        return;
      }

      // Find the largest font size that fits.
      let smallest = minimumFontSize;
      let largest = naturalFontSize;

      while (largest - smallest > 0.25) {
        const testSize = (smallest + largest) / 2;
        title.style.fontSize = `${testSize}px`;

        if (title.scrollWidth <= title.clientWidth) {
          smallest = testSize;
        } else {
          largest = testSize;
        }
      }

      title.style.fontSize = `${smallest.toFixed(2)}px`;
    });
  }

  function scheduleFit() {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(fitProductTitles);
  }

  // Run immediately.
  scheduleFit();

  // Recheck after the actual storefront font loads.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleFit);
  }

  window.addEventListener('resize', scheduleFit, { passive: true });
  document.addEventListener('shopify:section:load', scheduleFit);
})();